import { Injectable } from '@angular/core';
import {
  BookingServiceRequestInfo,
  BookingTravelerInfo
} from '@gtd/b2c-client';

@Injectable({
  providedIn: 'root'
})
export class SimService {
  hasSimServiceRequest(travelerInfos: BookingTravelerInfo[]): boolean {
    for (const traveler of travelerInfos) {
      if (traveler.serviceRequests) {
        for (const request of traveler.serviceRequests) {
          if (
            request.serviceType ===
            BookingServiceRequestInfo.ServiceTypeEnum.SIM
          ) {
            return true;
          }
        }
      }
    }
    return false;
  }
}
